import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { SystemCheck } from './SystemCheckCard';

interface StatusStatisticsProps {
  checks: SystemCheck[];
}

const StatusStatistics: React.FC<StatusStatisticsProps> = ({ checks }) => {
  const successCount = checks.filter(check => check.status === 'success').length;
  const warningCount = checks.filter(check => check.status === 'warning').length;
  const errorCount = checks.filter(check => check.status === 'error').length;
  const totalCount = checks.length;

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      <Card>
        <CardContent className="pt-6">
          <div className="text-2xl font-bold text-green-600">{successCount}</div>
          <p className="text-xs text-muted-foreground">Работает</p>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="pt-6">
          <div className="text-2xl font-bold text-yellow-600">{warningCount}</div>
          <p className="text-xs text-muted-foreground">Предупреждения</p>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="pt-6">
          <div className="text-2xl font-bold text-red-600">{errorCount}</div>
          <p className="text-xs text-muted-foreground">Ошибки</p>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="pt-6">
          <div className="text-2xl font-bold text-blue-600">
            {totalCount > 0 ? Math.round((successCount / totalCount) * 100) : 0}%
          </div>
          <p className="text-xs text-muted-foreground">Готовность</p>
        </CardContent>
      </Card>
    </div>
  );
};

export default StatusStatistics;
